import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/dialog';

import { getBlockIcon } from '../meta';
import type { BlockRegistry } from '../types';

interface AddComponentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  registry: BlockRegistry;
  /**
   * Block type keys offered in the grid — typically
   * `getPlaceableChildren(containerType, registry)` for the target container.
   */
  allowedTypes: string[];
  onSelect: (type: string) => void;
}

/** Grid of addable components (icon, name, description), registry-driven. */
export default function AddComponentDialog({
  open,
  onOpenChange,
  registry,
  allowedTypes,
  onSelect,
}: AddComponentDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>Add component</DialogTitle>
          <DialogDescription>Choose a component to add.</DialogDescription>
        </DialogHeader>

        {allowedTypes.length > 0 ? (
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
            {allowedTypes.map((type) => {
              const def = registry[type];
              if (!def) return null;
              return (
                <button
                  key={type}
                  type="button"
                  onClick={() => onSelect(type)}
                  className="flex flex-col items-center gap-2 rounded-lg border border-gray-200 p-4 text-center hover:border-zinc-400 hover:bg-zinc-50"
                >
                  <span className="text-zinc-600">
                    {getBlockIcon(type, 24)}
                  </span>
                  <span className="text-sm font-medium">{def.displayName}</span>
                  {def.description && (
                    <span className="text-xs text-zinc-500">
                      {def.description}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        ) : (
          <p className="py-6 text-center text-sm text-zinc-400">
            No components can be added here.
          </p>
        )}
      </DialogContent>
    </Dialog>
  );
}
